import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

const PrivateRoute = ({ user, children, redirect }) => {
  const authenticate = !!sessionStorage.getItem('deviceToken');
  
  const location = useLocation();
  return authenticate ? (
    children
  ) : (
    <Navigate
      to={`/auth/login?redirect=${encodeURIComponent(redirect || location.pathname)}`}
    />
  );
};

export default PrivateRoute;